import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import store from "../../../store/store";
import { addBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";

import AddUser from "../AddUser";

const InitMiddlewareAddUser:React.FC<any> = (props) => {
  const { addBrand, isSuccess } = useSelector(
    (state: any) => state.rootReducer?.brand
  );
  const navigate = useNavigate();

  useEffect(() => {
    const data: any = [
      {
        label: "Users",
        link: `/users`,
      },
      {
        label: "Add new User",
        link: ``,
      },
    ];
    store.dispatch(addBreadcrumb(data));
  }, []);
  

  if (isSuccess && addBrand?.data?.success === true) {
    navigate("/users")
    return null;
  } else {
    return <AddUser {...props} />;
  }
};

export default InitMiddlewareAddUser;
